import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export { cancelEvent, stopPropagation } from "./cancelEvent";
export { parameterAwareDebounce } from "./parameterAwareDebounce";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

let isMac = false;

if (typeof navigator !== "undefined") {
  const { platform } = navigator;
  if (
    platform?.startsWith("Mac") ||
    platform?.startsWith("iPhone") ||
    platform?.startsWith("iPad")
  ) {
    isMac = true;
  }
}

export { isMac };

// Extract URL from deployment content
export const extractDeploymentUrl = (content: string | undefined) => {
  if (!content) {
    return null;
  }
  const urlMatch = content.match(/https:\/\/[^\s]+\.fp\.dev[^\s]*/);
  return urlMatch ? urlMatch[0] : null;
};

// Generic status color mapping
const defaultStatusColors = {
  ready: "bg-green-500",
  failed: "bg-red-500",
  connecting: "bg-blue-500",
  authenticating: "bg-yellow-500",
  discovering: "bg-purple-500",
  success: "bg-green-500",
  error: "bg-red-500",
  pending: "bg-blue-500",
  warning: "bg-yellow-500",
  info: "bg-blue-500",
} as const;

/**
 * Convert a status to a Tailwind color class
 *
 * @param status - The status to convert
 * @param colorMap - Optional custom color mapping, defaults to standard status colors
 * @returns The Tailwind color class
 */
export function getStatusColor<T extends string>(
  status: T,
  colorMap?: Record<T, string>,
): string {
  const colors = colorMap || (defaultStatusColors as Record<T, string>);
  return colors[status] || "bg-gray-500";
}
